import { lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { motionTokens, springs } from "@/shared/lib/motion";

// Lecteur Remotion chargé à la demande : il n'alourdit pas le premier affichage.
const BannerPlayer = lazy(() => import("../../remotion/BannerPlayer"));

/**
 * Bandeau d'en-tête du tableau de bord : intitulé, nom de l'assureur, périmètre,
 * illustration.
 */
export function DashboardBanner({
  eyebrow,
  title,
  subtitle,
}: {
  eyebrow: string;
  title: string;
  subtitle: string;
}) {
  return (
    <section className="flex min-h-[8.5rem] flex-wrap items-center gap-4 overflow-hidden rounded-[var(--radius-card)] border border-border bg-[linear-gradient(90deg,#f7fbf5_0%,#eef8e7_45%,#cdf0b0_100%)] px-6 shadow-[var(--shadow-card)] dark:bg-[linear-gradient(90deg,#0f2125_0%,#10271f_55%,#1d3d17_100%)] lg:flex-nowrap">
      <motion.div
        className="min-w-0 shrink-0 py-6"
        initial={{ opacity: 0, x: -motionTokens.distance.md }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: motionTokens.duration.slow, ease: motionTokens.easing.smooth }}
      >
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">{eyebrow}</p>
        <h1 className="mt-1 text-2xl font-bold uppercase tracking-tight text-foreground sm:text-[1.75rem]">{title}</h1>
        <p className="mt-1 text-sm text-muted-foreground text-pretty">{subtitle}</p>
      </motion.div>

      {/* Illustration animée (Remotion) entre le texte et le sélecteur : elle monte à l'arrivée,
          se rétrécit puis disparaît faute de place. */}
      <motion.div
        className="pointer-events-none hidden h-[8.5rem] min-w-0 flex-1 self-end overflow-hidden lg:block [mask-image:linear-gradient(90deg,transparent,black_25%)]"
        initial={{ opacity: 0, y: motionTokens.distance.md * 2 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ ...springs.gentle, delay: motionTokens.stagger * 2 }}
        aria-hidden="true"
      >
        <Suspense fallback={null}>
          <BannerPlayer />
        </Suspense>
      </motion.div>

    </section>
  );
}
